import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem } from '../../../../../__styling'

export const StyledRaceSwingContainer = styled('div')({
    display: 'block',
    position: 'relative',
})

export const RaceSwingPercentContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'colorMode',
})<{ colorMode?: 'light' | 'dark' }>(({ colorMode }) => ({
    position: 'absolute',
    width: '100%',
    bottom: calcRem(-2),
    fontSize: calcRem(12),
    lineHeight: calcRem(12),
    fontWeight: 600,
    textAlign: 'center',
    ...(colorMode === 'dark' && {
        color: tokens.sevennews.colors.palette.alto,
    }),
}))
